import { RouteObject } from 'react-router-dom';
import { Offices } from '../index';
import { CreateOffice, EditOffice } from '../pages';

const OfficesRoutes: RouteObject[] = [
  {
    path: 'geography/offices',
    element: <Offices />,
  },
  {
    path: 'geography/offices/create',
    element: <CreateOffice />,
  },
  {
    path: 'geography/offices/edit/:id',
    element: <EditOffice />,
  },
];

export default OfficesRoutes;
